export enum QuestionType {
  ALL_QUESTIONS = 'allQuestions',
  SPECIFIC_QUESTIONS = 'specificQuestions',
  FREE_FORM_QUESTIONS = 'freeFormQuestions',
  MULTIPLE_CHOICE_QUESTIONS = 'multipleChoiceQuestion',
  TO_REVIEW_QUESTIONS = 'toReviewQuestions',
  VIDEO_RESPONSE = 'videoResponseQuestions',
  DOCUMENT_UPLOAD = 'documentUploadQuestions',
}

export type QuestionFormdataType = {
  questionId: string;
  questionType: string;
  isAnswerAccepted: boolean;
}[];
